import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
@Pipe({
    name: 'sort'
})
export class SortPipe implements PipeTransform {

    transform(value: any, by: string = 'name', ignore?: string): any {
        if (!value) {
            return;
        }

        const result: any = [];
        Object.keys(value).forEach(key => {
            if (!ignore || ignore !== key) {
                value[key].key = key;
                result.push(value[key]);
            }
        });

        return result.sort((a: any, b: any) => (a[by].toLowerCase() < b[by].toLowerCase()) ? -1 : (a[by].toLowerCase() > b[by].toLowerCase()) ? 1 : 0);
    }

}